const messages = {
  'aboutUs.groupImgAltText': 'Manos Sin Fonteras group',
  'aboutUs.text': 'This blog is a ',
  'aboutUs.textSecond': ' initiative, which has the objective of sharing unique knowledge and inspiring experiences from all over the world. ',
  'aboutUs.textThird': 'We invite you to read and learn about topics like wellbeing, emotions and mental health written from many different perspectives.',
  'aboutUs.textFourth': 'We will also share testimonies which reveal the benefits of Neural Stimulation and meditation, whether for work, in your studies or your personal life.',
  'aboutUs.textFifth': 'So sit back and enjoy each one of our articles.',
  'aboutUs.copyright': 'The articles in this page belong to Manos Sin Fronteras, unless otherwise stated.',
  'aboutUs.LJQuote': '"What is not shared is lost"',
  'aboutUs.manos': 'Manos Sin Fronteras',

  'article.author': 'by. ',
  'article.contribute': 'Join our network of writers and use our platform to share your knowledge.',

  'category.selfawareness': 'Self Awareness',
  'category.emptyQuery': 'No matching articles have been found',
  'category.mentalHealth': 'Mental Health',
  'category.others': 'Others',
  'category.physicalWellbeing': 'Physical Wellbeing',
  'category.noMoreViolence': '#hearMeToo',
  'category.reflections': 'Reflections',

  'categories.title': 'Categories',

  'contact.name': 'Name',
  'contact.email': 'Email',
  'contact.message': 'Message',
  'contact.submit': 'Send',
  'contact.worldMap': 'MSF Worldwide',

  'contribute.altText': 'writing hand drawing',
  'contribute.text': 'Would you like to be part of our team of collaborators? Perfect, send us an article or a testimony with regards to a subject you are passionate about. ',
  'contribute.secondText': 'Your knowledge and experiences are the life of this blog.',
  'contribute.thirdText': 'Do not worry if writing is not your strength, we are prepared to guide you in the process',
  'contribute.join': 'Join our network of writers and surprise us with your message in our next “newsletter”!',
  'contribute.translation': 'Our team will take care of translations.',

  'footer.manos.label': 'MSF_int',
  'footer.manos.altText': 'Monochrome World',
  'footer.yoMedito.label': 'I Meditate',
  'footer.yoMedito.altText': 'Monochrome Balloon',
  'footer.laJardinera.label': 'La Jardinera',
  'footer.laJardinera.altText': 'Monochrome Flower',
  'footer.copyright': '© 2018 Manos Sin Fronteras',

  'legal.address.label': 'Registered Address',
  'legal.address.line1': 'Manos Sin Fronteras Internacionales',
  'legal.address.line2': 'C/ Ribargorza no. 18',
  'legal.address.line3': 'Entresuelo B de Zaragoza',
  'legal.address.line4': '50003 (Zaragoza)',
  'legal.contact.email': 'E-mail: ',
  'legal.contact.phone': 'Tel: +34 658 77 46 78',
  'legal.contact.website': 'Website: ',
  'legal.representative.label': 'Legal Representative',
  'legal.representative.name': 'Lucía Peña',
  'legal.representative.with': 'Registered with: Diputación General de Aragón',
  'legal.representative.number': 'Register number: 01-Z-2070-2007',
  'legal.representative.code': 'Identification code: G99197394',
  'legal.disclaimer.label': 'Disclaimer',
  'legal.disclaimer.text': 'The content of this website is based on Spanish norms, unless otherwise stated. The opinions published in these articles represent the views of the authors and not those of the Manos Sin Fronteras Blog or its creators. If there are any suggestions or complaints with regards with anything published, we would appreciate you letting us know through the contact us section. Every article published here has the express consent of its author.',

  'locale.en': 'English',
  'locale.es': 'Español',
  'locale.it': 'Italiano',
  'locale.pt': 'Português',

  'meta.description.aboutUs': 'We are Manos Sin Fronteras (Hands Without Borders) and we have created this blog to share inspiring experiences and knowledge. We are also sharing testimonies which reveal the benefits of Neural Stimulation.',
  'meta.description.contactUs': 'Would you like to share your unique experience or knowledge with us? Do you have comments about the site or the articles we share? Write to us and we will reply promptly.',
  'meta.description.contribute': 'We invite you to share with our readers that subject you are so passionate about or those experiences which have been fundamental for your personal growth. Sharing is the life of this blog!',
  'meta.description.home': 'Welcome to the Hands Without Borders Blog! We invite you to enjoy our articles related to physical wellbeing, mental health and personal growth.',
  'meta.description.mentalHealth': 'Read articles that dive into facing situations and everyday tension in a healthy way. These are real situations, experienced by our authors. Discover how they have managed to recover a mental and emotional balance.',
  'meta.description.others': 'In this page you will find interesting articles of varied subject that we could not fit into our other categories.',
  'meta.description.physicalWellbeing': 'Here you will find articles about creating healthy habits and improving your physical well being as well as the link between the body, the mind and emotions.',
  'meta.description.selfawareness': 'Learn about people\'s journey to knowing themselves and how meditation, Neural Stimulation or the Special Trips have sped up this self awareness. ',
  'meta.description.noMoreViolence': 'I inhale, exhale and I take ownership of my life, 5 minutes for our voice',

  'menu.aboutUs': 'About Us',
  'menu.contactUs': 'Contact Us',
  'menu.contribute': 'Contribute',
  'menu.home': 'Home',
  'menu.legal': 'Legal Notice',

  'sidePanel.estimulacionNeural.altText': 'Neural Stimulation',
  'sidePanel.estimulacionNeural.text': 'A technique to help you improve your physical and emotional stability',
  'sidePanel.estimulacionNeural.title': 'Neural Stimulation',
  'sidePanel.laJardinera.altText': 'Pink Flower',
  'sidePanel.laJardinera.text': 'Has dedicated her life to helping the planet as the forerunner of Neural Stimulation',
  'sidePanel.laJardinera.title': 'La Jardinera',
  'sidePanel.yoMedito.altText': 'I Meditate - Balloon',
  'sidePanel.yoMedito.text': 'When you are at peace, the world is at peace',
  'sidePanel.yoMedito.title': 'I Meditate',

  'template.comments': 'Write your Comments',
};

export default messages;
